import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApiService } from '../../services/api.service';
import { ToastService } from '../../services/toast.service';
import { ConfirmService } from '../../services/confirm.service';
import { Impostazioni, VoceFrequente, SpesaCantiere, CantiereFoto, Cliente } from '../../models';

@Component({
  selector: 'app-impostazioni',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="page-container">
      <div class="header-flex">
        <div>
          <h1>Centro Bottega & Impostazioni</h1>
          <p class="subtitle">Gestisci dati fiscali PDF, libreria voci frequenti, spese materiali e foto cantiere</p>
        </div>
      </div>

      <!-- Navigation Tabs -->
      <div class="settings-tabs">
        <button class="tab-btn" [class.active]="activeTab === 'profilo'" (click)="activeTab = 'profilo'">
          <span class="material-icons">badge</span> Profilo & Azienda
        </button>
        <button class="tab-btn" [class.active]="activeTab === 'voci'" (click)="activeTab = 'voci'">
          <span class="material-icons">bolt</span> Voci Frequenti (Preset)
        </button>
        <button class="tab-btn" [class.active]="activeTab === 'spese'" (click)="activeTab = 'spese'">
          <span class="material-icons">receipt</span> Spese Materiali
        </button>
        <button class="tab-btn" [class.active]="activeTab === 'foto'" (click)="activeTab = 'foto'">
          <span class="material-icons">photo_camera</span> Foto Prima & Dopo
        </button>
      </div>

      <!-- TAB 1: PROFILO & AZIENDA -->
      <div *ngIf="activeTab === 'profilo'" class="card form-card">
        <div class="card-swatch-top"></div>
        <form (ngSubmit)="saveSettings()">
          <div class="section-title">
            <span class="material-icons">badge</span>
            <h2>Dati Anagrafici & Fiscali</h2>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Ragione Sociale / Nome Attività</label>
              <input type="text" [(ngModel)]="settings.ragione_sociale" name="ragione_sociale" placeholder="Es. Rock & Rullo Tinteggiature" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Nome Titolare</label>
              <input type="text" [(ngModel)]="settings.nome" name="nome" placeholder="Es. Guido" />
            </div>
            <div class="form-group">
              <label>Cognome Titolare</label>
              <input type="text" [(ngModel)]="settings.cognome" name="cognome" placeholder="Es. Rossi" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Partita IVA</label>
              <input type="text" [(ngModel)]="settings.partita_iva" name="partita_iva" placeholder="Es. IT01234567890" />
            </div>
            <div class="form-group">
              <label>Codice Fiscale</label>
              <input type="text" [(ngModel)]="settings.codice_fiscale" name="codice_fiscale" placeholder="Es. RSSGDU80A01B157X" />
            </div>
          </div>

          <hr class="divider" />

          <div class="section-title">
            <span class="material-icons">location_on</span>
            <h2>Sede Legale & Indirizzo</h2>
          </div>

          <div class="form-row">
            <div class="form-group flex-2">
              <label>Indirizzo Via/Piazza</label>
              <input type="text" [(ngModel)]="settings.indirizzo" name="indirizzo" placeholder="Es. Via Milano 45" />
            </div>
            <div class="form-group flex-1">
              <label>CAP</label>
              <input type="text" [(ngModel)]="settings.cap" name="cap" placeholder="Es. 25121" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group flex-2">
              <label>Città</label>
              <input type="text" [(ngModel)]="settings.citta" name="citta" placeholder="Es. Brescia" />
            </div>
            <div class="form-group flex-1">
              <label>Provincia (Sigla)</label>
              <input type="text" [(ngModel)]="settings.provincia" name="provincia" placeholder="Es. BS" maxLength="4" />
            </div>
          </div>

          <hr class="divider" />

          <div class="section-title">
            <span class="material-icons">contact_phone</span>
            <h2>Contatti & Coordinate Bancarie</h2>
          </div>

          <div class="form-row">
            <div class="form-group">
              <label>Telefono / Cellulare</label>
              <input type="text" [(ngModel)]="settings.telefono" name="telefono" placeholder="Es. 333 9876543" />
            </div>
            <div class="form-group">
              <label>Email Professionale</label>
              <input type="email" [(ngModel)]="settings.email" name="email" placeholder="Es. guido@imbianchino.it" />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group flex-2">
              <label>IBAN (per bonifici fatture)</label>
              <input type="text" [(ngModel)]="settings.iban" name="iban" placeholder="Es. IT60X0542811101000000123456" />
            </div>
            <div class="form-group flex-1">
              <label>Banca / Istituto</label>
              <input type="text" [(ngModel)]="settings.banca" name="banca" placeholder="Es. Intesa Sanpaolo" />
            </div>
          </div>

          <hr class="divider" />

          <div class="section-title">
            <span class="material-icons">article</span>
            <h2>Note Pie' di Pagina Documenti (Fatture / Preventivi)</h2>
          </div>

          <div class="form-group">
            <label>Dicitura Regime Fiscale / Note in calce al PDF</label>
            <textarea [(ngModel)]="settings.note_pie_pagina" name="note_pie_pagina" rows="3" placeholder="Es. Operazione in regime forfettario esenta da IVA ai sensi della L. 190/2014."></textarea>
          </div>

          <div class="form-actions">
            <button type="submit" class="btn-primary btn-save" [disabled]="saving">
              <span class="material-icons">save</span>
              <span>{{ saving ? 'Salvataggio...' : 'Salva Impostazioni' }}</span>
            </button>
          </div>
        </form>
      </div>

      <!-- TAB 2: VOCI FREQUENTI -->
      <div *ngIf="activeTab === 'voci'" class="card form-card">
        <div class="card-swatch-top"></div>
        <div class="section-title">
          <span class="material-icons">bolt</span>
          <h2>Libreria Voci Frequenti (Preset Lavori)</h2>
        </div>
        <p class="tab-desc">Salva le lavorazioni più comuni per poterle inserire nei preventivi con un singolo click.</p>

        <form (ngSubmit)="createVoce()" class="preset-form">
          <div class="form-row">
            <div class="form-group flex-2">
              <label>Descrizione Lavoro *</label>
              <input type="text" [(ngModel)]="newVoce.descrizione" name="descrizione" required placeholder="Es. Tinteggiatura pareti con idropittura lavabile..." />
            </div>
            <div class="form-group flex-1">
              <label>Prezzo Unitario (€) *</label>
              <input type="number" [(ngModel)]="newVoce.prezzo_unitario" name="prezzo_unitario" step="0.01" required placeholder="0.00" />
            </div>
            <div class="form-group" style="display: flex; align-items: flex-end;">
              <button type="submit" class="btn-primary" style="width: 100%;">Aggiungi Preset</button>
            </div>
          </div>
        </form>

        <table class="data-table" style="margin-top: 24px;">
          <thead>
            <tr>
              <th>Descrizione Lavoro</th>
              <th width="150">Prezzo Unitario</th>
              <th width="80" style="text-align: right;">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of vociFrequenti">
              <td><strong>{{ v.descrizione }}</strong></td>
              <td>€ {{ v.prezzo_unitario | number:'1.2-2' }}</td>
              <td style="text-align: right;">
                <button class="btn-sm btn-danger" (click)="deleteVoce(v.id!)" title="Elimina"><span class="material-icons" style="font-size: 16px;">delete</span></button>
              </td>
            </tr>
            <tr *ngIf="vociFrequenti.length === 0">
              <td colspan="3" class="text-center">Nessuna voce frequente salvata.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TAB 3: SPESE MATERIALI -->
      <div *ngIf="activeTab === 'spese'" class="card form-card">
        <div class="card-swatch-top" style="background: var(--accent);"></div>
        <div class="section-title">
          <span class="material-icons">receipt</span>
          <h2>Registro Spese Materiali (Colorificio & Fornitori)</h2>
        </div>
        <p class="tab-desc">Traccia gli acquisti di vernici, rulli e materiali associati ai cantieri per calcolare il margine.</p>

        <form (ngSubmit)="createSpesa()" class="preset-form">
          <div class="form-row">
            <div class="form-group">
              <label>Cliente / Cantiere</label>
              <select [(ngModel)]="newSpesa.cliente_id" name="spesa_cliente">
                <option [value]="undefined">Generale / Nessun cliente specifico</option>
                <option *ngFor="let c of clienti" [value]="c.id">{{ c.cognome }} {{ c.nome }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Data *</label>
              <input type="date" [(ngModel)]="newSpesa.data" name="spesa_data" required />
            </div>
          </div>
          <div class="form-row">
            <div class="form-group flex-2">
              <label>Descrizione Spesa / Materiale *</label>
              <input type="text" [(ngModel)]="newSpesa.descrizione" name="spesa_desc" required placeholder="Es. 2 latte smalto acrilico bianco + rulli" />
            </div>
            <div class="form-group flex-1">
              <label>Importo (€) *</label>
              <input type="number" [(ngModel)]="newSpesa.importo" name="spesa_importo" step="0.01" required placeholder="0.00" />
            </div>
            <div class="form-group" style="display: flex; align-items: flex-end;">
              <button type="submit" class="btn-primary" style="width: 100%;">Registra Spesa</button>
            </div>
          </div>
        </form>

        <div class="total-spese" *ngIf="speseCantiere.length > 0">
          <span>Totale Spese Registrate: <strong>€ {{ calculateTotalSpese() | number:'1.2-2' }}</strong></span>
        </div>

        <table class="data-table" style="margin-top: 24px;">
          <thead>
            <tr>
              <th>Data</th>
              <th>Cliente / Cantiere</th>
              <th>Descrizione Spesa</th>
              <th width="130">Importo</th>
              <th width="80" style="text-align: right;">Azioni</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let s of speseCantiere">
              <td>{{ s.data | date:'dd/MM/yyyy' }}</td>
              <td>{{ s.cognome ? (s.cognome + ' ' + s.nome) : 'Generale' }}</td>
              <td><strong>{{ s.descrizione }}</strong></td>
              <td><strong>€ {{ s.importo | number:'1.2-2' }}</strong></td>
              <td style="text-align: right;">
                <button class="btn-sm btn-danger" (click)="deleteSpesa(s.id!)" title="Elimina"><span class="material-icons" style="font-size: 16px;">delete</span></button>
              </td>
            </tr>
            <tr *ngIf="speseCantiere.length === 0">
              <td colspan="5" class="text-center">Nessuna spesa registrata.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- TAB 4: FOTO CANTIERE (PRIMA E DOPO) -->
      <div *ngIf="activeTab === 'foto'" class="card form-card">
        <div class="card-swatch-top" style="background: var(--success);"></div>
        <div class="section-title">
          <span class="material-icons">photo_camera</span>
          <h2>Galleria Foto Cantiere (Prima & Dopo)</h2>
        </div>
        <p class="tab-desc">Documenta lo stato delle superfici prima e dopo la tinteggiatura per il tuo portfolio.</p>

        <form (ngSubmit)="createFoto()" class="preset-form">
          <div class="form-row">
            <div class="form-group">
              <label>Cliente / Cantiere *</label>
              <select [(ngModel)]="newFoto.cliente_id" name="foto_cliente" required>
                <option [value]="undefined">Seleziona cliente...</option>
                <option *ngFor="let c of clienti" [value]="c.id">{{ c.cognome }} {{ c.nome }}</option>
              </select>
            </div>
            <div class="form-group">
              <label>Stadio Lavoro *</label>
              <select [(ngModel)]="newFoto.tipo" name="foto_tipo" required>
                <option value="prima">📸 Prima dell'intervento</option>
                <option value="dopo">✨ Dopo la tinteggiatura</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group flex-2">
              <label>Immagine (Seleziona file o scatta foto) *</label>
              <input type="file" accept="image/*" (change)="onFileSelected($event)" required style="padding: 9px;" />
            </div>
            <div class="form-group flex-2">
              <label>Descrizione / Ambiente</label>
              <input type="text" [(ngModel)]="newFoto.descrizione" name="foto_desc" placeholder="Es. Parete soggiorno stucco veneziano" />
            </div>
            <div class="form-group" style="display: flex; align-items: flex-end;">
              <button type="submit" class="btn-primary" style="width: 100%;">Carica Foto</button>
            </div>
          </div>
        </form>

        <div class="photo-gallery-grid" style="margin-top: 28px;">
          <div class="photo-card" *ngFor="let f of cantiereFoto">
            <div class="photo-badge" [class.badge-dopo]="f.tipo === 'dopo'">{{ f.tipo === 'prima' ? 'PRIMA' : 'DOPO' }}</div>
            <img [src]="f.immagine_path" [alt]="f.descrizione || 'Foto cantiere'" />
            <div class="photo-info">
              <strong>{{ f.cognome }} {{ f.nome }}</strong>
              <p>{{ f.descrizione || 'Senza descrizione' }}</p>
              <button class="btn-sm btn-danger" (click)="deleteFoto(f.id!)" style="margin-top: 8px;"><span class="material-icons" style="font-size: 14px;">delete</span> Rimuovi</button>
            </div>
          </div>
          <div class="text-center" *ngIf="cantiereFoto.length === 0" style="grid-column: 1 / -1;">
            Nessuna foto cantiere caricata.
          </div>
        </div>
      </div>

    </div>
  `,
  styles: [`
    .page-container { max-width: 1000px; margin: 0 auto; padding-bottom: 40px; }
    .header-flex { margin-bottom: 24px; }
    h1 { margin: 0; color: var(--text-main); font-size: 28px; font-weight: 800; letter-spacing: -0.5px; }
    .subtitle { color: var(--text-muted); margin: 4px 0 0; font-size: 14px; }

    /* Settings Tabs */
    .settings-tabs {
      display: flex;
      gap: 10px;
      margin-bottom: 24px;
      overflow-x: auto;
      padding-bottom: 4px;
    }
    .tab-btn {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      background: var(--surface);
      border: 1px solid var(--border);
      padding: 12px 20px;
      border-radius: 12px;
      font-weight: 600;
      font-size: 14px;
      color: var(--text-muted);
      cursor: pointer;
      transition: all 0.2s;
      white-space: nowrap;
    }
    .tab-btn:hover { background: var(--bg-main); color: var(--text-main); }
    .tab-btn.active {
      background: var(--primary);
      color: white;
      border-color: var(--primary);
      box-shadow: 0 4px 12px rgba(200, 90, 50, 0.3);
    }
    .tab-btn .material-icons { font-size: 18px; }

    .tab-desc {
      color: var(--text-muted);
      font-size: 14px;
      margin-top: -12px;
      margin-bottom: 24px;
    }

    .success-banner {
      background: rgba(13, 148, 136, 0.12);
      border: 1px solid var(--success);
      color: var(--success);
      padding: 14px 20px;
      margin-bottom: 24px;
      display: flex;
      align-items: center;
      gap: 12px;
      font-weight: 700;
      font-size: 14px;
      border-radius: 12px;
    }

    .form-card { padding: 32px 28px; }

    .section-title {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 18px;
      color: var(--primary);
    }
    .section-title .material-icons { font-size: 22px; }
    .section-title h2 { margin: 0; font-size: 18px; font-weight: 700; color: var(--text-main); }

    .divider {
      border: none;
      border-top: 1px solid var(--border);
      margin: 28px 0;
    }

    .form-row { display: flex; gap: 16px; margin-bottom: 16px; }
    .form-group { flex: 1; margin-bottom: 0; }
    .flex-1 { flex: 1; }
    .flex-2 { flex: 2; }

    label { display: block; margin-bottom: 6px; font-weight: 600; font-size: 13px; color: var(--text-main); }
    input, select, textarea { width: 100%; padding: 12px 14px; border: 1px solid var(--border); border-radius: 8px; font-size: 14px; box-sizing: border-box; background: var(--bg-main); transition: all 0.2s; color: var(--text-main); }
    input:focus, select:focus, textarea:focus { border-color: var(--primary); outline: none; background: var(--surface); box-shadow: 0 0 0 3px var(--primary-light); }

    .form-actions { display: flex; justify-content: flex-end; margin-top: 32px; padding-top: 20px; border-top: 1px solid var(--border); }
    .btn-save { padding: 14px 28px; font-size: 15px; }

    .data-table { width: 100%; border-collapse: collapse; text-align: left; }
    .data-table th, .data-table td { padding: 14px 18px; border-bottom: 1px solid var(--border); font-size: 14px; color: var(--text-main); }
    .data-table th { background: var(--bg-main); color: var(--text-muted); font-weight: 700; text-transform: uppercase; font-size: 12px; }
    .text-center { text-align: center; color: var(--text-muted); padding: 30px !important; }

    .btn-sm { display: inline-flex; align-items: center; justify-content: center; width: 32px; height: 32px; border-radius: 6px; border: 1px solid var(--border); background: var(--surface); color: var(--text-muted); cursor: pointer; transition: all 0.2s; }
    .btn-sm:hover { background: var(--bg-main); color: var(--text-main); }
    .btn-danger { background: rgba(239, 68, 68, 0.1); border-color: rgba(239, 68, 68, 0.2); color: var(--danger); }
    .btn-danger:hover { background: var(--danger); color: white; }

    .total-spese { margin-top: 20px; text-align: right; font-size: 16px; color: var(--text-main); }

    /* Photo Gallery */
    .photo-gallery-grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
    }
    @media (max-width: 768px) {
      .photo-gallery-grid { grid-template-columns: 1fr; }
      .form-row { flex-direction: column; gap: 16px; }
    }
    .photo-card {
      background: var(--bg-main);
      border: 1px solid var(--border);
      border-radius: 12px;
      overflow: hidden;
      position: relative;
      box-shadow: var(--shadow);
    }
    .photo-badge {
      position: absolute;
      top: 10px;
      left: 10px;
      background: #c85a32;
      color: white;
      padding: 4px 10px;
      border-radius: 20px;
      font-size: 11px;
      font-weight: 800;
      z-index: 2;
    }
    .badge-dopo { background: var(--success); }
    .photo-card img {
      width: 100%;
      height: 180px;
      object-fit: cover;
      display: block;
    }
    .photo-info {
      padding: 14px;
    }
    .photo-info strong { font-size: 14px; color: var(--text-main); display: block; }
    .photo-info p { margin: 4px 0 0 0; font-size: 12px; color: var(--text-muted); }
  `]
})
export class ImpostazioniComponent implements OnInit {
  activeTab: 'profilo' | 'voci' | 'spese' | 'foto' = 'profilo';
  settings: Impostazioni = {};
  saving = false;
  successMessage = '';

  clienti: Cliente[] = [];
  vociFrequenti: VoceFrequente[] = [];
  speseCantiere: SpesaCantiere[] = [];
  cantiereFoto: CantiereFoto[] = [];

  newVoce: VoceFrequente = { descrizione: '', prezzo_unitario: 0 };
  newSpesa: SpesaCantiere = { descrizione: '', importo: 0, data: new Date().toISOString().substring(0, 10) };
  newFoto: Partial<CantiereFoto> = { tipo: 'prima', descrizione: '' };

  constructor(
    private apiService: ApiService,
    private toastService: ToastService,
    private confirmService: ConfirmService
  ) {}

  ngOnInit() {
    this.loadAll();
  }

  loadAll() {
    this.apiService.getImpostazioni().subscribe({
      next: (data) => this.settings = data || {},
      error: (err) => console.error('Errore caricamento impostazioni', err)
    });
    this.apiService.getClienti().subscribe(data => this.clienti = data);
    this.apiService.getVociFrequenti().subscribe(data => this.vociFrequenti = data);
    this.apiService.getSpeseCantiere().subscribe(data => this.speseCantiere = data);
    this.apiService.getCantiereFoto().subscribe(data => this.cantiereFoto = data);
  }

  saveSettings() {
    this.saving = true;
    this.successMessage = '';
    this.apiService.updateImpostazioni(this.settings).subscribe({
      next: (res) => {
        this.settings = res;
        this.saving = false;
        this.successMessage = 'Impostazioni salvate con successo! I nuovi dati verranno usati nei PDF.';
        this.toastService.success('Impostazioni salvate con successo!');
        setTimeout(() => this.successMessage = '', 4000);
      },
      error: (err) => {
        this.saving = false;
        this.toastService.error(err.error?.error || 'Errore durante il salvataggio');
      }
    });
  }

  // Voci Frequenti
  createVoce() {
    if (!this.newVoce.descrizione) {
      this.toastService.warning('Inserisci la descrizione della voce');
      return;
    }
    this.apiService.createVoceFrequente(this.newVoce).subscribe({
      next: () => {
        this.toastService.success('Voce frequente aggiunta');
        this.newVoce = { descrizione: '', prezzo_unitario: 0 };
        this.apiService.getVociFrequenti().subscribe(data => this.vociFrequenti = data);
      },
      error: (err) => this.toastService.error(err.error?.error || 'Errore creazione voce')
    });
  }

  async deleteVoce(id: number) {
    const conf = await this.confirmService.confirm('Elimina Voce', 'Vuoi eliminare questa voce frequente?', 'Elimina', 'Annulla', true);
    if (conf) {
      this.apiService.deleteVoceFrequente(id).subscribe({
        next: () => {
          this.toastService.success('Voce eliminata');
          this.apiService.getVociFrequenti().subscribe(data => this.vociFrequenti = data);
        },
        error: (err) => this.toastService.error(err.error?.error || 'Errore eliminazione')
      });
    }
  }

  // Spese Cantiere
  createSpesa() {
    if (!this.newSpesa.descrizione || this.newSpesa.importo === undefined) {
      this.toastService.warning('Compila descrizione e importo');
      return;
    }
    this.apiService.createSpesaCantiere(this.newSpesa as SpesaCantiere).subscribe({
      next: () => {
        this.toastService.success('Spesa registrata con successo');
        this.newSpesa = { descrizione: '', importo: 0, data: new Date().toISOString().substring(0, 10) };
        this.apiService.getSpeseCantiere().subscribe(data => this.speseCantiere = data);
      },
      error: (err) => this.toastService.error(err.error?.error || 'Errore registrazione spesa')
    });
  }

  async deleteSpesa(id: number) {
    const conf = await this.confirmService.confirm('Elimina Spesa', 'Vuoi eliminare questa spesa?', 'Elimina', 'Annulla', true);
    if (conf) {
      this.apiService.deleteSpesaCantiere(id).subscribe({
        next: () => {
          this.toastService.success('Spesa eliminata');
          this.apiService.getSpeseCantiere().subscribe(data => this.speseCantiere = data);
        },
        error: (err) => this.toastService.error(err.error?.error || 'Errore eliminazione')
      });
    }
  }

  calculateTotalSpese(): number {
    return this.speseCantiere.reduce((sum, s) => sum + parseFloat(String(s.importo || 0)), 0);
  }

  // Cantiere Foto
  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.newFoto.immagine_path = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  }

  createFoto() {
    if (!this.newFoto.cliente_id || !this.newFoto.tipo || !this.newFoto.immagine_path) {
      this.toastService.warning('Seleziona cliente, stadio (prima/dopo) e immagine');
      return;
    }
    this.apiService.createCantiereFoto(this.newFoto as CantiereFoto).subscribe({
      next: () => {
        this.toastService.success('Foto cantiere caricata con successo');
        this.newFoto = { tipo: 'prima', descrizione: '' };
        this.apiService.getCantiereFoto().subscribe(data => this.cantiereFoto = data);
      },
      error: (err) => this.toastService.error(err.error?.error || 'Errore caricamento foto')
    });
  }

  async deleteFoto(id: number) {
    const conf = await this.confirmService.confirm('Elimina Foto', 'Vuoi eliminare questa foto dalla galleria?', 'Elimina', 'Annulla', true);
    if (conf) {
      this.apiService.deleteCantiereFoto(id).subscribe({
        next: () => {
          this.toastService.success('Foto rimossa');
          this.apiService.getCantiereFoto().subscribe(data => this.cantiereFoto = data);
        },
        error: (err) => this.toastService.error(err.error?.error || 'Errore rimozione foto')
      });
    }
  }
}
